/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, isObject } from '../twd'

export default ({ 
    field, form, id:id_, cls='', error, prefix='', suffix='', options=[], 
    value, label, labelStyle={}, labelClass='', 
    dataName='twd-fields-select', 
    optionStyle={}, 
    ...props 
} = {}) => {

    const id = id_ || getId()

    let err = form && form.errors && form.errors[field.name]

    let chg = props.onChange
        || ((e) => { form.setFieldValue(field.name, e.target.value || '') })

    return (
    <React.Fragment>
    {label && <label htmlFor={id} style={labelStyle} className={labelClass}>{label}</label>}

    <div className={ 'select-wrapper' + (err || error ? ' has-error': '')}>
    <select
        data-name={dataName}
        className="form-control"
        id={id}
        {...field}
        {...props}
        {...(err || error ? {"aria-invalid":true} : {})}
        onChange={chg}
        defaultValue={value}
    >{
        options
            .map(a => isObject(a) ? a : { label:a, value:a })
            .map((a,i) => {
                return <option
                    data-name={dataName + '-option'}
                    key={i}
                    hidden={!a.value}
                    disabled={!a.value}
                    aria-hidden={!a.value}
                    style={optionStyle}
                    value={a.value}>{a.label}</option>
            })
    }</select>
    { err && <label className="field-status has-error">{err}</label> }
    </div>

    </React.Fragment>)
}
